module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/auth/forgotpassword/forgotpassword.component.css
// module id = ./src/app/auth/forgotpassword/forgotpassword.component.css
// module chunks = main